import { type Common } from '../common.js';
import {
  type FilterOptions,
  type ProvidersWithSupportedValues,
  type SafeProviderWithPractices,
} from '../models/previsit/provider.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/organizations';

  constructor(common: Common) {
    this.common = common;
  }

  async getProvider(orgId: string, userId: string): Promise<SafeProviderWithPractices> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${orgId}/providers/${userId}`);
    const { provider } = await this.common.getJSON(url);
    return provider;
  }

  async findAllByOrganizationId(
    orgId: string,
    filterOptions: FilterOptions = {}
  ): Promise<ProvidersWithSupportedValues> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${orgId}/providers`, filterOptions);
    const allProviders = await this.common.getJSON(url);
    return allProviders;
  }

  async getProviderId(orgId: string, slug: string): Promise<string> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${orgId}/providers/slug/${slug}`);
    const { providerUserId } = await this.common.getJSON(url);
    return providerUserId;
  }
}
